<div class="card">
  <div class="card-header row g-2 align-items-center">

    <div class="col-lg-2">
      <h6 class="card-title"> Map View </h6>
    </div>

    <div class="col-lg-2">
      <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.name" type="text" class="form-control" placeholder="Search by Industry Name">
    </div>

    <div class="col-lg-2">
      <input autocomplete="off" pattern="^[^<>]*$" [(ngModel)]="searchField.ocmms_id" type="text" class="form-control" placeholder="Search by OCMMS ID">
    </div>

    <div class="col-lg-2">
      <select [(ngModel)]="searchField.status" class="form-select">
        <option value=""> Select Status </option>
        <option value="online"> Online </option>
        <option value="offline"> Offline </option>
        <option value="delay"> Delay </option>
      </select>
    </div>
    <div class="col-lg-1">
      <button type="button" class="btn btn-info btn-sm text-white">
        <strong>Total Unit Station</strong>
        <span class="badge bg-info">{{industriesLocation.length}}</span>
      </button>
    </div>

    <div class="col-lg-2 text-end">
      <button *ngIf="!mapLoader" style="margin-right: 10px;" (click)="getIndustryLocations()" type="submit" class="btn btn-primary">
        <strong>Go</strong>
      </button>

      <button *ngIf="!mapLoader" (click)="resetFilter()" type="button" class="btn btn-danger">
        <strong>Reset</strong>
      </button>

      <img *ngIf="mapLoader" style="margin-top: -10px; height: 60px;" src="/assets/images/load.gif" />
    </div>


  </div>

  <div class="clearfix"></div>

  <div class="position-relative" id="industryMap" style="margin-top: 15px; height: 550px;">
    <agm-map [usePanning]="true" [fullscreenControl]="true" [mapTypeControl]="true" [zoom]="zoom" [latitude]="centerLat" [longitude]="centerLng">
      <agm-marker-cluster imagePath="../assets/images/cluster/m">
        <agm-marker
          (markerClick)="select_marker(infoWindow)"
          title="{{industries.code ? industries.code : 'NA'}} | {{industries.name}}"
          *ngFor="let industries of industriesLocation"
          [latitude]="industries.latitude"
          [longitude]="industries.longitude"
          [iconUrl]="(((industries.last_update_date | industryStatus) == 'Online') ? '../assets/images/markers/online.png' : ( ((industries.last_update_date | industryStatus) == 'Delay') ? '../assets/images/markers/delay.png' : '../assets/images/markers/close.png'))">

          <agm-info-window #infoWindow [disableAutoPan]="false">
            <div class="info-window" style="width: 400px; height: 300px;">
              <table class="table table-striped">
                <tr>
                  <td><strong>Unit Station Code</strong></td>
                  <td>{{industries.code}}</td>
                </tr>
                <tr>
                  <td><strong>Unit Station Name</strong></td>
                  <td>{{industries.name}}</td>
                </tr>
                <tr>
                  <td><strong>Address</strong></td>
                  <td>{{industries.address}}</td>
                </tr>
                <tr>
                  <td><strong>City</strong></td>
                  <td>{{industries.city}}</td>
                </tr>
                <tr>
                  <td><strong>SPCB Regional Office</strong></td>
                  <td>{{industries.spcb_regional_office}}</td>
                </tr>
                <tr>
                  <td><strong>OCMMS Id</strong></td>
                  <td>{{industries.hr_ocmms_id}}</td>
                </tr>
                <tr>
                  <td>
                    <img title="Online" *ngIf="(industries.last_update_date | industryStatus) == 'Online'" src="/assets/images/profile-icon/online.png" style="width: 40%; margin-left: 5%;">
                    <img title="Offline" *ngIf="(industries.last_update_date | industryStatus) == 'Offline'" src="/assets/images/profile-icon/offline.png" style="width: 40%; margin-left: 5%;">
                    <img title="Delay" *ngIf="(industries.last_update_date | industryStatus) == 'Delay'" src="/assets/images/profile-icon/delay.png" style="width: 40%; margin-left: 5%;">
                  </td>
                  <td class="text-end pe-0">
                    <button class="btn btn-sm" style="padding: 5px 10px; background-color: #38B2F7;" title="More detail">
                      <a style="color: #fff;" [routerLink]="['/industry']" [queryParams]="{industry_id: industries.id | base64:'encode'}">
                        <strong><i class="icon icon-graph"></i> More</strong>
                      </a>
                    </button>
                  </td>
                </tr>
              </table>

              <div *ngIf="userLevel != 'vendor' && ocmmsApplicationList && ocmmsApplicationList[industries.hr_ocmms_id]">
                <button *ngFor="let application of ocmmsApplicationList[industries.hr_ocmms_id]; let i = index" class="btn btn-primary btn-sm me-1" title="Download Certificate">
                  <a [attr.data-index]="i" download href="http://ocmms.nic.in/OCMMS_NEW/download.action?applicationId={{application['application_id']}}&industryState={{state}}&industryType={{application['application_type']}}&industryFor={{application['application_for']}}" target="_blank" style="text-decoration: none; color: #fff;">
                    <strong><i class="icon icon-file-pdf"></i> Certificate {{i + 1}}</strong>
                  </a>
                </button>
              </div>
            </div>
          </agm-info-window>
        </agm-marker>
      </agm-marker-cluster>
    </agm-map>
  </div>
</div>
